<template>
  <div class="container login-page">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <card class="card-login card-white">
        <!-- <template slot="header">
          <div >
            <img src="/img/login_img.jfif" alt />
            <h1 class="card-title">L</h1>
          </div>
        </template> -->
        <img src="/img/login_img.jfif" alt />
        <b-form @submit.prevent="login">
          <div>
            <FadeAlertDanger ref="alert" :msg="msgErro" />
            <b-form-group label="Forma rastreio" label-for="trackingEntryType">
              <b-form-select
                v-model="trackingEntryType"
                id="trackingEntryType"
                :options="trackingEntryTypeOptions"
              ></b-form-select>
            </b-form-group>
            <div v-if="trackingEntryType == 'CPF'">
              <b-form-group label="CPF" label-for="input-personalDocument">
                <b-form-input
                  type="text"
                  id="input-personalDocument"
                  placeholder="Informe o CPF"
                  v-model="personalDocument"
                  v-mask="'999.999.999-99'"
                />
              </b-form-group>
            </div>
            <div v-else>
              <b-form-group label="CNPJ" label-for="input-companyDocument">
                <b-form-input
                  type="text"
                  id="input-companyDocument"
                  placeholder="Informe o CNPJ da empresa"
                  v-model="companyDocument"
                  v-mask="'99.999.999/9999-99'"
                />
              </b-form-group>
            </div>
          </div>
          <div slot="footer">
            <base-button
              native-type="submit"
              type="primary"
              class="mb-3"
              size="lg"
              block
            >
              Rastrear
            </base-button>
          </div>
        </b-form>
      </card>
    </div>
  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import AwesomeMask from "awesome-mask";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";

extend("email", email);
extend("min", min);

extend("required", required);

export default {
  data() {
    return {
      companyDocument: "",
      personalDocument: "",
      msgErro: "",
      trackingEntryType: "CPF",
      trackingEntryTypeOptions: ["CPF", "CNPJ"],
    };
  },
  components: {
    FadeAlertDanger,
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    async login() {
      try {
        let authTracking = {
          entryType: this.trackingEntryType,
          companyDocument: this.companyDocument,
          personalDocument: this.personalDocument,
        };

        await this.$store
          .dispatch("loginTrackingClient", authTracking)
          .then(() => {
            this.$router.push("/trackingClient/opened");
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              this.msgErro = error.response.data.message;
            } else {
              this.msgErro = error.toString();
            }
            this.$refs.alert.show();
          });
      } catch (e) {
        console.log(e);
        this.msgErro = "Erro inexperado";
        this.$refs.alert.show();
      }
    },
  },
};
</script>
<style scoped>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.login-page .card-login.card-white {
  background: #f7f7f7;
}
.card-body .twoOptions {
  text-align: center;
  padding-right: 20px;
  color: #344675;
  margin-bottom: 0px;
}

.card-body img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 767.98px) {
  .card-body img {
    width: 275px;
  }
}
</style>
